import { Button, Pagination } from "@mui/material";
import React, { useEffect, useState } from "react";
import Rightbar from "../../../../layout/components/Rightbar/Rightbar";
import Selectmenu from "../../../../layout/components/Selectmenu/Selectmenu";
import Tabheader from "../../../../layout/components/Tabheader/Tabheader";
import Table from "../../../../layout/components/Table/Table";
import Tabledata from "../../../../layout/components/Table/Table";
import Tabswitch from "../../../../layout/components/Tabswitch/Tabswitch";
import { get } from "../../../../utils/api";

import CreateInvoiceIcon from "../../../../layout/assets/images/Tabheader/create-invoice-add.svg";
import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import List from "./List";
import Header from "./Header/index";
// import Summary from "./Summary/index";
import NewCollectionSequence from "../collection-sequences/New/index";
import EditCollectionSequenceDetails from "./edit";
import CollectionSequenceDetails from "../collection-sequences/details";

function CollectionSequences() {
 

  return (
    <Routes>
      <Route
        element={
          <>
            <Header />
            <Outlet />
          </>
        }
      >
        <Route path="/list" element={<List />} />
        <Route
          path="new-collection-sequence"
          element={
            <>
              <NewCollectionSequence />
            </>
          }
        />
        <Route
        path="details/:id"
          element={
            <>
              <CollectionSequenceDetails />
            </>
          }
        />
        <Route
          path="edit-collection-sequence/:id"
          element={
            <>
              <EditCollectionSequenceDetails />
            </>
          }
        />
        {/* <Route path="/summary" element={<Summary />} /> */}

        <Route index element={<Navigate to="/admin/collection-sequences/list" />} />
      </Route>
    </Routes>
  );
}

export default CollectionSequences;



